import {
  mapLangeTitleObjects,
  pushOtrosToEndByAttributeName,
} from '../../../utils/array-filtrer';
import { orderAlphabaticallyByAttribute } from 'src/app/utils/array-filtrer';
import { RoutingConfig } from 'src/app/utils/routing-config';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';
import Partner from 'src/app/models/partner.model';
import { MyPartnersAPI } from '../../../apis/partners.service';
import { Preferences } from '@capacitor/preferences';
import { dev } from '../../../config/offlines_keys.json';
import { ToastUtils } from '../../../utils/toast_builder';
import routes from '../../../config/routing.json';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map, switchMap, take, filter } from 'rxjs/operators';
import { from, lastValueFrom, of } from 'rxjs';
import { PhotoEditorComponent } from 'src/app/components/personal-data/profile-photo/photo-editor/photo-editor.component';
import { PhotoService, PhotoTaken } from 'src/app/services/photo.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Store, props } from '@ngrx/store';
import Owner from 'src/app/models/owner.model';
import {
  addPartner,
  loadPartnerType,
  updatePartner,
} from 'src/app/utils/states-management/actions/partner.action';
import { cloneDeep } from 'lodash';
import { getCountry } from 'src/app/utils/states-management/selector/countries.selector';
import { PorductionEditorComponent } from '../../farm/others-agricol-product-components/porduction-editor/porduction-editor.component';
import { ListableProduction } from 'src/app/models/farm/production_per_farm';
import { addActivity } from 'src/app/utils/states-management/actions/activity.action';
@Component({
  selector: 'app-modal-activity',
  templateUrl: './modal-activity.component.html',
  styleUrls: ['./modal-activity.component.scss'],
  // providers: [MyPartnersAPI],
})
export class ModalActivityComponent implements OnInit {
  owner_id: number;
  country;
  @Input() activities;
  isDashboardView;
  partner = new Partner();
  partner_list;
  headerLabel;
  add_partner: boolean = false;
  emptyArray = false;
  owner: Owner;
  @Input() openedFromCashflow = false;
  selectedActivity
  constructor(
    public modalController: ModalController,
    public translateService: TranslateService,
    private router: Router,
    private partnersAPI: MyPartnersAPI,
    private toastUtils: ToastUtils,
    private routingConfig: RoutingConfig,
    private photoService: PhotoService,
    private sanitizer: DomSanitizer,
    private store: Store<{ owner: Owner; partners: Partner }>
  ) { }

  addPartner() {
    this.add_partner = true;
    this.partner.id = null;
    this.partner.name = null;
  }

  async translate() {
    this.headerLabel =
      (await lastValueFrom(
        this.translateService.get('titles.activity_add_btn')
      ))
  }
  existedPartner = [];
  @ViewChild(PorductionEditorComponent)
  productionEditorComponent: PorductionEditorComponent;

  slideOpts = {
    initialSlide: 0,
    speed: 400,
    allowTouchMove: false,
  };
  async ngOnInit() {
    //TODO change crop name in header
    this.owner = await lastValueFrom(this.store.select('owner').pipe(take(1)));
    this.translate();
    this.translateService.onLangChange.subscribe((value: string) => {
      this.translate();
    });
    // let ClassName = 'ModalActivityComponent';
    // this.formConfig = (
    //   await this.routingConfig.getPageFormConfig(ClassName)
    // ).modal;

    this.isDashboardView = this.router.url.includes(routes.dashboard.home);
  }
  products: Array<ListableProduction> = [];

  confirm_method() {


    this.store.dispatch(
      addActivity({
        activity: this.selectedActivity,
        production_list: this.products
      })
    );
    this.modalController.dismiss({
      dismissed: true,
    });
  }
  addProduction(data) {
    if (Array.isArray(data)) {
      this.products = cloneDeep(data);
    }
  }
  isDisabled = true;
  image_path;
  submitForm() { }
  updateForm() { }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  valueChanged() {
    this.emptyArray = true;
  }


}
